import React, { useRef, useState } from 'react';
import {
    CheckBoxContainer,
    ColumnContainer,
    SetCount,
    Type,
    ActionButton,
    Status,
    StatusText,
    Counter,
    TagContainer,
    ListContainerRightItems,
    Text,
    InputBox,
    AccountTitle
} from './CondensedMobileView.styled';
import CondensedMobileViewHeader from './CondensedMobileViewHeader';
// import { AccountTitle } from './CondensedMobileView.styled';
import { ImageBox } from 'src/pages/consignmentAdd/components/submit/ShippingDetails.styled';
import {Spinner } from 'src/common/refactoredComponents/searchDropdown/SearchDropdown.styled.jsx';
import { ImageContainer } from 'src/pages/consignmentAdd/components/cart/productGuide/ProductGuide.styled';
import Checkbox from 'src/common/refactoredComponents/checkbox/Checkbox';
import CheckBoxTransfer from './CheckBoxTransfer';
import { StyledTextDiv } from 'src/pages/consignmentAdd/components/cart/priceOverride/utils/reportUsage.styled';
import AddCartButton from 'src/common/atomics/addCartButton/AddCartButton';
import AddCartIcon from '../../atomics/addCartButton/AddCartIcon';
import { CheckMarkImg } from './CondensedMobileView.styled';
import { ITEMSDETAILS } from 'src/pages/equity/components/common/constants';
import TissueItemIcon from 'src/assets/images/TissueItemIcon.svg';
import NonTissueItemIcon from 'src/assets/images/NonTissueItemIcon.svg';
import BOMChanges from 'src/assets/images/BOMChanges.svg';
import StorageRequest from 'src/assets/images/storage-request.svg';
import CountBadge from 'src/common/refactoredComponents/countBadge/CountBadge';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
import { sizes } from 'src/styles/Media.styled';
import {
    isTransferSurgery, getCartCount
} from 'src/utils/util';
import { useTranslation } from 'react-i18next';
import subtract from 'src/assets/images/subtract.svg';
import AddBlack2 from 'src/assets/images/AddBlack2.svg';
import CheckMark from 'src/assets/images/CheckMark.svg';
import AddBlue from 'src/assets/images/AddBlue.svg';
import { useSelector } from 'react-redux';

const ColumnContainerItems = ({
    isEquityTemplate,
    countryISOCode,
    isBundlesChildren,
    isCartScreenOrProductGuide,
    setOrItemDetails,
    isExpanded,
    isOrderScreen,
    expandedCard,
    onToggle,
    setExpandedCard,
    setBundleChildrenFlag,
    onSetItemClick,
    setNameColor,
    clickable,
    setNameFontSizeDesktop,
    setNameFontSizeMobile,
    setNameLetterSpacing,
    enableTemplateCardSpecificStyling,
    reviewPage,
    priceOverridePage,
    isShippingScreen,
    isSetDetailPage,
    isconsignmentAddOrder,
    isEquity,
    isTemplateDetail,
    orderType,
    isProductGuideScreen,
    reviewScreen,
    isLanguageChanged,
    isFromTemplates = false,
    isFromSurgeryTemplate,
    isProductguidePage,
    isConsignmentAdd,
    isReviewSubmitScreen,
    isItemDetailPage,
    isOrderDetailTab,
    productBomDetails,
    cartPage,
    onBomClick,
    marginRight,
    fontSize,
    typeFontSize,
    isProductDetails,
    showCheckBox,
    isChildItem,
    handleSetSelection,
    productKeyBundle,
    productWithIsPlaceHolderSet,
    shipDontShipSurgery,
    inventoryShipping,
    handleLocationChange,
    selectedLocation,
    allocatedData,
    isCounterButton,
    quantityValue,
    isQuickOrder,
    removeCount,
    quickOrderFlag,
    updateItemsCount,
    parentIndex,
    index,
    setIsQuantityMoreThan50,
    setQuantityValue,
    subitem,
    inputOnChange,
    updateProductQuantity,
    childItemProductkey,
    addCount,
    isFromConsignmentAdd,
    isFromIndependentProductGuide,
    isOnlyPlusButton,
    isProductAdded,
    addCard,
    selectedSegment,
    isSurgery,
    isEquityPage=false,
    isFromEquity = false,
    cartProducts = [],
    isEquityTemplateBundlePopup = false,
}) => {
    const {
        productCFN,
        cfn,
        quantity,
        uom,
        type,
        isSet,
        bom,
        salesOrg,
        productKey,
        materialType,
        isPlaceHolderAdded,
        isDeleteButtonPresent,
    } = setOrItemDetails || {};
    const isFixedWidth =
        !isFromSurgeryTemplate &&
        !isProductguidePage &&
        !isConsignmentAdd &&
        !isReviewSubmitScreen &&
        !isSetDetailPage &&
        !isItemDetailPage &&
        !isOrderDetailTab &&
        !isShippingScreen &&
        !reviewScreen;
    const winWidth = window.innerWidth;
    const { t } = useTranslation();
    const specialCharactersRegex =
        /[ a-zA-Z`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
    const removeLeadingZeros = (val) => {
        return String(val).replace(/^0+/, '') || '0';
    };
    const validateQuantity = (value) => {
        const limitTwoDigits = /^\d{0,2}$/;
        parseInt(value) > 50 &&
            !priceOverridePage &&
            setIsQuantityMoreThan50(true);
        if (
            limitTwoDigits.test(value) &&
            (parseInt(value) <= 50 || value == '')
        ) {
            setQuantityValue(value);
            value != '' &&
                (subitem || priceOverridePage
                    ? inputOnChange(value, productKey)
                    : inputOnChange(value));
        }
    };
    const TemplateCheckBox = ({
        item,
        checkBoxDetails,
        productWithIsPlaceHolderSet,
    }) => {
        return (
            <CheckBoxContainer>
                <Checkbox
                    name={checkBoxDetails.name}
                    onCheckboxSelectionChange={checkBoxDetails.onChange}
                    checked={checkBoxDetails.checked}
                    id={checkBoxDetails.id}
                    disabled={productWithIsPlaceHolderSet?.some(
                        (data) => data.cfn === item.cfn
                    )}
                    background={'none'}
                    checkboxBorder={'1.5px solid #555555'}
                    alignItemDirection={'center'}
                    hoverEffect={'false'}
                    disableFocusEffect={'true'}
                />
            </CheckBoxContainer>
        );
    };

    const loadingStatusArray = useSelector(
        (state) => state.validateProductsReducer?.loadingStatusArray || []
    );
    const consignmentAddLoadingStatusArray = useSelector(
        (state) => state.consignmentAddValidateProductsReducer?.loadingStatusArray || []
    );
    const equityLoadingStatusArray = useSelector(
        (state) => state.equityValidateProductsReducer?.loadingStatusArray || []
    );
    const validatedProducts = useSelector((state) =>
        isFromEquity
            ? state.equityValidateProductsReducer?.validatedProducts || []
            : isConsignmentAdd
            ? state.consignmentAddValidateProductsReducer?.validatedProducts || []
            : state.validateProductsReducer?.validatedProducts || []
    );

    const isProductLoading = 
    isFromEquity?
    ((Array.isArray(equityLoadingStatusArray)
        ? equityLoadingStatusArray.some(
                (product) =>
                    product?.loading &&
                    product?.cfn === (setOrItemDetails?.cfn || setOrItemDetails?.productCFN)
            )  
        : false))
    : isConsignmentAdd?
        (Array.isArray(consignmentAddLoadingStatusArray)
        ? consignmentAddLoadingStatusArray.some(
                (product) =>
                    product?.loading &&
                    product?.cfn === (setOrItemDetails?.cfn || setOrItemDetails?.productCFN) &&
                    (product?.salesOrg === setOrItemDetails?.salesOrg)
            ) : false)
    : Array.isArray(loadingStatusArray)
        ? loadingStatusArray.some(
                (product) =>
                    product?.loading &&
                    product?.cfn === (setOrItemDetails?.cfn || setOrItemDetails?.productCFN) &&
                    (product?.salesOrg === setOrItemDetails?.salesOrg)
            )
        : false;

    const matchedValidatedProduct = Array.isArray(validatedProducts) 
        ? validatedProducts.find(
                (product) =>
                    (product?.cfn || product?.productCFN) ===
                        (setOrItemDetails?.cfn || setOrItemDetails?.productCFN) &&
                    (!setOrItemDetails?.salesOrg ||
                        product?.salesOrg === setOrItemDetails?.salesOrg)
            )
        : null;
    const isProductAddedStatus = Boolean(
        isProductAdded ||
            setOrItemDetails?.productAdded ||
            matchedValidatedProduct?.productAdded
    );
    const cartCount = getCartCount(cartProducts, setOrItemDetails);
    const [isAddPending, setIsAddPending] = useState(false);
    const [showCheckMark, setShowCheckMark] = useState(false);
    const wasProductAddedRef = useRef(false);
    const checkMarkTimerRef = useRef(null);

    if (isProductAddedStatus) {
        wasProductAddedRef.current = true;
    }

    useEffectWithErrorLogging(() => {
        if (isProductLoading) {
            setIsAddPending(true);
            return;
        }

        if (!isAddPending) {
            return undefined;
        }

        if (matchedValidatedProduct || isProductAddedStatus) {
            setIsAddPending(false);
            return undefined;
        }

        const timer = setTimeout(() => {
            setIsAddPending(false);
        }, 300);

        return () => clearTimeout(timer);
    }, [
        isAddPending,
        isProductAddedStatus,
        isProductLoading,
        matchedValidatedProduct,
    ]);

    useEffectWithErrorLogging(() => {
        if (isProductAddedStatus) {
            wasProductAddedRef.current = true;
            setShowCheckMark(true);
            clearTimeout(checkMarkTimerRef.current);
            return;
        }

        if (wasProductAddedRef.current && showCheckMark) {
            clearTimeout(checkMarkTimerRef.current);
            checkMarkTimerRef.current = setTimeout(() => {
                setShowCheckMark(false);
                wasProductAddedRef.current = false;
            }, 1200);
        } else {
            setShowCheckMark(false);
        }
    }, [
        isProductAddedStatus,
        showCheckMark,
    ]);

    useEffectWithErrorLogging(() => {
        return () => {
            clearTimeout(checkMarkTimerRef.current);
        };
    }, []);

    const shouldShowLoader = isProductLoading || isAddPending;

    return (
        <ColumnContainer>
            <CondensedMobileViewHeader
                isEquityTemplate={isEquityTemplate}
                countryISOCode={countryISOCode}
                isBundlesChildren={isBundlesChildren}
                productCFN={productCFN}
                cfn={cfn}
                bom={bom}
                isCartScreenOrProductGuide={isCartScreenOrProductGuide}
                isExpanded={isExpanded}
                isOrderScreen={isOrderScreen}
                expandedCard={expandedCard}
                onToggle={onToggle}
                productKey={productKey}
                setExpandedCard={setExpandedCard}
                setBundleChildrenFlag={setBundleChildrenFlag}
                onSetItemClick={onSetItemClick}
                setOrItemDetails={setOrItemDetails}
                setNameColor={setNameColor}
                clickable={clickable}
                setNameFontSizeDesktop={setNameFontSizeDesktop}
                setNameFontSizeMobile={setNameFontSizeMobile}
                setNameLetterSpacing={setNameLetterSpacing}
                enableTemplateCardSpecificStyling={enableTemplateCardSpecificStyling}
                isFixedWidth={isFixedWidth}
                winWidth={winWidth}
                reviewPage={reviewPage}
                priceOverridePage={priceOverridePage}
                isShippingScreen={isShippingScreen}
                isSetDetailPage={isSetDetailPage}
                isconsignmentAddOrder={isconsignmentAddOrder}
                salesOrg={salesOrg}
                uom={uom}
                type={type}
                isQuickOrder={isQuickOrder}
            />

            {(isEquity ||
                isEquityTemplate ||
                isTemplateDetail ||
                cartPage ||
                (isOrderScreen && orderType === 'ZOR')) &&
                !isProductGuideScreen && (
                    <ColumnContainer
                        style={{
                            justifyContent: 'flex-start',
                            marginLeft: isShippingScreen
                                ? '-10px'
                                : reviewScreen
                                    ? '10px'
                                    : '-17px',
                            marginTop: isShippingScreen
                                ? '1px'
                                : '0px',
                            marginRight:
                                winWidth >= 390 ? '0px' : '-12px',
                            ...(!isShippingScreen &&
                                !reviewScreen && {
                                marginLeft:
                                    winWidth >= 390
                                        ? '-17px'
                                        : '-12px',
                                marginRight:
                                    winWidth >= 390
                                        ? '0px'
                                        : '-24px',
                            }),
                        }}
                    >
                        <AccountTitle
                            marginTop={'0px'}
                            marginRight={'0px'}
                            isLanguageChange={isLanguageChanged}
                            isEquityTemplate={isEquityTemplate}
                            isUSUser={countryISOCode === 'US'}
                        >
                            {!(
                                (materialType &&
                                    materialType ==
                                    ITEMSDETAILS[2]
                                        .materialType[
                                    'bundle'
                                    ]) ||
                                (Object.prototype.hasOwnProperty.call(
                                    setOrItemDetails,
                                    'bundleItems'
                                ) &&
                                    setOrItemDetails?.bundleItems
                                        ?.length > 0)
                            ) &&
                                setOrItemDetails?.salesOrg ===
                                'S030' &&
                                countryISOCode === 'US' && (
                                    <span>
                                        <img
                                            src={TissueItemIcon}
                                            alt="T"
                                            style={{
                                                height: '15px',
                                                width: '34px',
                                                marginBottom:
                                                    '-5px',
                                            }}
                                        />
                                    </span>
                                )}
                            {!(
                                (materialType &&
                                    materialType ==
                                    ITEMSDETAILS[2]
                                        .materialType[
                                    'bundle'
                                    ]) ||
                                (Object.prototype.hasOwnProperty.call(
                                    setOrItemDetails,
                                    'bundleItems'
                                ) &&
                                    setOrItemDetails?.bundleItems
                                        ?.length > 0)
                            ) &&
                                setOrItemDetails?.salesOrg ===
                                'S002' &&
                                countryISOCode === 'US' && (
                                    <span>
                                        <img
                                            src={NonTissueItemIcon}
                                            alt="T"
                                            style={{
                                                height: '15px',
                                                width: '34px',
                                                marginBottom:
                                                    '-5px',
                                            }}
                                        />
                                    </span>
                                )}
                        </AccountTitle>
                    </ColumnContainer>
                )}
            {!isFromSurgeryTemplate &&
                !isProductguidePage &&
                !isConsignmentAdd &&
                // !isReviewSubmitScreen &&
                !isSetDetailPage &&
                !isItemDetailPage &&
                !isOrderDetailTab && (
                    <>
                        <ColumnContainer
                            style={{
                                justifyContent: 'flex-start',
                                marginLeft: isShippingScreen
                                    ? '-10px'
                                    : reviewScreen
                                        ? '10px'
                                        : '-17px',
                                marginTop: isShippingScreen
                                    ? '1px'
                                    : '0px',
                                marginRight:
                                    winWidth >= 390
                                        ? '0px'
                                        : '-12px',
                                ...(!isShippingScreen &&
                                    !reviewScreen && {
                                    marginLeft:
                                        winWidth >= 390
                                            ? '-17px'
                                            : '-24px',
                                    marginRight:
                                        winWidth >= 390
                                            ? '0px'
                                            : '-24px',
                                }),
                            }}
                        >
                            {!isShippingScreen && !reviewScreen && (
                                <>
                                    <AccountTitle
                                        marginTop={'0px'}
                                        marginRight={'0px'}
                                        isLanguageChange={
                                            isLanguageChanged
                                        }
                                        isEquityTemplate={
                                            isEquityTemplate
                                        }
                                        isUSUser={
                                            countryISOCode === 'US'
                                        }
                                    >
                                        {productBomDetails.find(
                                            (bomDetail) =>
                                                bomDetail.prodcutCFN ===
                                                setOrItemDetails?.productCFN ||
                                                bomDetail.prodcutCFN ===
                                                setOrItemDetails.cfn
                                        )
                                            ?.billOfMaterialsHistory && (
                                                <ImageBox>
                                                    <ImageContainer
                                                        id='condensedview-bomClick'
                                                        src={BOMChanges}
                                                        alt="BOM"
                                                        isExpanded={
                                                            expandedCard
                                                        }
                                                        onClick={() => {
                                                            // setExpandedCard(
                                                            //     !expandedCard
                                                            // );
                                                            onBomClick(
                                                                setOrItemDetails
                                                            );
                                                        }}
                                                        style={{
                                                            marginRight:
                                                                '0px',
                                                            display: isFromTemplates ? 'none' : 'flex'
                                                                
                                                        }}
                                                    />
                                                </ImageBox>
                                            )}
                                    </AccountTitle>
                                </>
                            )}
                            <AccountTitle
                                marginRight={'-10px'}
                                marginLeft={'0px'}
                                isLanguageChange={isLanguageChanged}
                                isEquityTemplate={isEquityTemplate}
                                isUSUser={countryISOCode === 'US'}
                            >
                                {setOrItemDetails?.isReservationSet && (
                                    <ImageBox>
                                        <ImageContainer
                                            src={StorageRequest}
                                            id='condensed-storage-request'
                                            alt="storage-request"
                                            isExpanded={
                                                expandedCard
                                            }
                                            onClick={() => {
                                                setExpandedCard(
                                                    !expandedCard
                                                );
                                            }}
                                            style={{
                                                marginRight:
                                                    winWidth < 390
                                                        ? '22px'
                                                        : '17px',
                                                marginLeft:
                                                    winWidth < 390
                                                        ? '-22px'
                                                        : '-17px',
                                                display: 'flex',
                                            }}
                                        />
                                    </ImageBox>
                                )}
                            </AccountTitle>
                        </ColumnContainer>
                    </>
                )}
            {(reviewPage || priceOverridePage) &&
                !isconsignmentAddOrder ? (
                salesOrg == 'S030' ? (
                    <TagContainer
                        style={{
                            marginRight: priceOverridePage
                                ? '-112px'
                                : '-150px',
                        }}
                    >
                        <Status style={{ marginTop: '10px' }}>
                            <StatusText>{uom || type}</StatusText>
                        </Status>
                    </TagContainer>
                ) : (
                    <TagContainer
                        style={{
                            marginRight: priceOverridePage
                                ? '-112px'
                                : '-150px',
                        }}
                    >
                        <Status style={{ marginTop: '10px' }}>
                            <StatusText>{uom || type}</StatusText>
                        </Status>
                    </TagContainer>
                )
            ) : null}

            <ListContainerRightItems>
                {!cartPage &&
                    !isProductguidePage &&
                    setOrItemDetails?.quantity && (
                        <ActionButton
                            paddingLeft={
                                isTemplateDetail
                                    ? '62px'
                                    : isShippingScreen ||
                                        isSetDetailPage
                                        ? '62px'
                                        : '54px'
                            }
                            marginRight={isEquity ? '10px' : marginRight}
                        >
                            <SetCount
                                marginRight={marginRight}
                                fontSize={fontSize}
                                whiteSpace={'nowrap'}
                                marginLeft={
                                    window.innerWidth <=
                                        sizes.mobileDevice &&
                                        isTransferSurgery()
                                        ? '0px'
                                        : '0px'
                                }
                            >
                                {!isProductguidePage &&
                                    setOrItemDetails.quantity}{' '}
                                x
                                <Type typeFontSize={typeFontSize}>
                                    {isSet ? t(
                                        'orders.shipTrackLabels.setLabel'
                                    ) : uom || type}
                                </Type>
                            </SetCount>
                        </ActionButton>
                    )}                                      
                {!isReviewSubmitScreen &&
                    !isOrderScreen &&
                    !isProductGuideScreen &&
                    !isProductDetails &&
                    !isTemplateDetail && (
                        <CheckBoxContainer
                            mbMargin={
                                isTransferSurgery() ? '0px' : '0px'
                            }
                        >                            
                            {!cartPage && !isConsignmentAdd &&
                                !isShippingScreen &&
                                !isFromTemplates &&                                
                                showCheckBox && (
                                    <TemplateCheckBox
                                        item={setOrItemDetails}
                                        checkBoxDetails={{
                                            name: setOrItemDetails.cfn,
                                            id: setOrItemDetails.description,
                                            onChange: () => {
                                                (setOrItemDetails &&
                                                    setOrItemDetails.materialType &&
                                                    setOrItemDetails.materialType ==
                                                    ITEMSDETAILS[2]
                                                        .materialType[
                                                    'bundle'
                                                    ]) ||
                                                    isChildItem
                                                    ? handleSetSelection(
                                                        isChildItem
                                                            ? setOrItemDetails.cfn
                                                            : setOrItemDetails.productKey,
                                                        !setOrItemDetails.isChecked,
                                                        isChildItem
                                                            ? 'children'
                                                            : 'parent',
                                                        isChildItem
                                                            ? productKeyBundle
                                                            : '',
                                                        !setOrItemDetails.isChecked
                                                    )
                                                    : handleSetSelection(
                                                        setOrItemDetails.productKey,
                                                        !setOrItemDetails.isChecked
                                                    );
                                            },
                                            checked:
                                                setOrItemDetails.isChecked,
                                        }}
                                        productWithIsPlaceHolderSet={
                                            productWithIsPlaceHolderSet
                                        }
                                    />
                                )}
                            {shipDontShipSurgery !==
                                'NOT_VISIBLE' &&
                                isShippingScreen &&
                                showCheckBox &&
                                setOrItemDetails.isSet &&
                                !setOrItemDetails.isReservationSet &&
                                (isTransferSurgery() &&
                                    setOrItemDetails.status &&
                                    (countryISOCode === 'JP'
                                        ? setOrItemDetails.status !==
                                        'Not Allocated'
                                        : true) ? (
                                    <CheckBoxTransfer
                                        item={setOrItemDetails}
                                        inventoryShipping={
                                            inventoryShipping
                                        }
                                        countryISOCode={
                                            countryISOCode
                                        }
                                        handleLocationChange={
                                            handleLocationChange
                                        }
                                        checked={
                                            !setOrItemDetails.shippingRequirement
                                        }
                                        selectedLocation={
                                            selectedLocation
                                        }
                                        allocatedData={
                                            allocatedData
                                        }
                                    />
                                ) : (
                                    shipDontShipSurgery !==
                                    'NOT_VISIBLE' &&
                                    isShippingScreen &&
                                    showCheckBox &&
                                    setOrItemDetails.isSet &&
                                    !isTemplateDetail &&
                                    !setOrItemDetails.isReservationSet && (
                                        <Checkbox
                                            onCheckboxSelectionChange={() => {
                                                if (
                                                    !inventoryShipping
                                                ) {
                                                    handleLocationChange(
                                                        setOrItemDetails.productKey,
                                                        !setOrItemDetails.shippingRequirement
                                                    );
                                                }
                                            }}
                                            checked={!setOrItemDetails.shippingRequirement}
                                            id="common-CondensedMobileView-shippingRequirement-checkbox"
                                            disabled={inventoryShipping}
                                            background={'none'}
                                            checkboxBorder={'1.5px solid #555555'}
                                            alignItemDirection={'center'}
                                            hoverEffect={'false'}
                                            disableFocusEffect={'true'}
                                            margin={'0px -4px 0px 5px'}
                                        />
                                    )
                                ))}
                        </CheckBoxContainer>
                    )}
            </ListContainerRightItems>
            {priceOverridePage && (
                <StyledTextDiv
                    color={'#202124'}
                    fontSize={'13px'}
                    textAlign={'center'}
                    style={{ marginRight: '12px' }}
                >
                    {t('ConsignmentAdd.common.feesAndItems.qty')}
                </StyledTextDiv>
            )}
            {cartPage && isCounterButton && (
                <ActionButton
                    isBundlesChildren={isBundlesChildren}
                    paddingLeft={'0px'}
                    isEquityTemplateBundlePopup={isEquityTemplateBundlePopup}
                >
                    <>
                        <AddCartButton
                            className={
                                quantityValue <= 0 ||
                                    isPlaceHolderAdded ||
                                    isDeleteButtonPresent === false
                                    ? 'disabled'
                                    : ''
                            }
                            width={'29px'}
                            height={'29px'}
                            border={'unset'}
                            id={`item-decrease-quantity-button-${productCFN || cfn || bom}`}
                            onClick={() =>
                                isQuickOrder
                                    ? removeCount(
                                        setOrItemDetails.cfn,
                                        setOrItemDetails.isSet,
                                        setOrItemDetails
                                    )
                                    : removeCount(quantityValue)
                            }
                            backgroundColor="transparent"
                            boxShadow="none"
                            visibility={
                                isDeleteButtonPresent === false
                                    ? 'hidden'
                                    : ''
                            }
                        >
                            <AddCartIcon
                                mobilePath={subtract}
                                width={'19px'}
                                height={'19px'}
                            />
                        </AddCartButton>
                    </>
                    {quickOrderFlag ? (
                        <InputBox
                            type="text"
                            maxLength="3"
                            value={setOrItemDetails.quantity}
                            onChange={(e) => {
                                const value = e.target.value;
                                if (
                                    !specialCharactersRegex.test(
                                        value
                                    )
                                ) {
                                    updateItemsCount(
                                        parentIndex,
                                        value,
                                        productKey,
                                        index
                                    );
                                }
                            }}
                            disabled={
                                setOrItemDetails.quantity === 0
                            }
                        />
                    ) : !(isEquity || isEquityTemplate) ? (
                        <Text background="transparent">
                            {/* {quantityValue} */}
                            {quantity}
                        </Text>
                    ) : (
                        <Counter
                            type="text"
                            value={quantityValue}
                            onChange={(e) => {
                                validateQuantity(e.target.value),
                                    updateProductQuantity(
                                        removeLeadingZeros(
                                            e.target.value
                                        ),
                                        childItemProductkey
                                            ? productKeyBundle
                                            : productKey,
                                        childItemProductkey
                                    );
                            }}
                            onBlur={() =>
                                setIsQuantityMoreThan50(false)
                            }
                        />
                    )}
                    <>
                        <AddCartButton
                            className={
                                // Prioritize: if isQuickOrder and setOrItemDetails.isPlusIconDisable, always disable
                                isQuickOrder && setOrItemDetails.isPlusIconDisable
                                    ? 'disabled'
                                    : isEquity || isEquityTemplate
                                        ? quantityValue >= 50 ? 'disabled' : ''
                                        : quantityValue >= 50 ||
                                            isPlaceHolderAdded ||
                                            (!isSet &&
                                                isDeleteButtonPresent === false)
                                            ? 'disabled'
                                            : ''
                            }
                            visibility={
                                isEquity || isEquityTemplate
                                    ? ''
                                    : !isSet &&
                                        isDeleteButtonPresent ===
                                        false
                                        ? 'hidden'
                                        : ''
                            }
                            width={'29px'}
                            height={'29px'}
                            border={'unset'}
                            id={`item-increase-quantity-button-${productCFN || cfn || bom}`}
                            onClick={() => {
                                (isEquity &&
                                    materialType === 'DIEN') ||
                                    isQuickOrder
                                    ? addCount(setOrItemDetails)
                                    : addCount(
                                        productKey,
                                        isSet,
                                        '',
                                        quantityValue
                                    );
                            }}
                            boxShadow="none"
                            backgroundColor="transparent"
                        >
                            <AddCartIcon
                                mobilePath={AddBlack2}
                                width={'19px'}
                                height={'19px'}
                            />
                        </AddCartButton>
                    </>
                </ActionButton>
            )}
            {isProductguidePage && (
                <ActionButton
                    paddingLeft={'0px'}
                    marginLeft={isFromConsignmentAdd && '10px'}
                >
                    <>
                        <SetCount
                            marginRight={marginRight}
                            fontSize={fontSize}
                            style={{
                                marginRight: isProductguidePage
                                    ? '15px'
                                    : isFromConsignmentAdd
                                        ? '20px'
                                        : '25px',
                            }}
                        >
                            <Type typeFontSize={typeFontSize}>
                                {isSet ? t(
                                        'orders.shipTrackLabels.setLabel'
                                    ) : uom || type}
                            </Type>
                        </SetCount>

                        {
                            !isFromIndependentProductGuide && isOnlyPlusButton && (
                                <ActionButton
                                    enableTemplateCardSpecificStyling={
                                        enableTemplateCardSpecificStyling
                                    }
                                    center={
                                        enableTemplateCardSpecificStyling
                                    }
                                    marginRight={'5px'}
                                    paddingLeft={'0px'}
                                    id={`set-item-add-cart-button-${productCFN || cfn || bom
                                        }`}
                                > 
                                    <AddCartButton
                                        id={'condensedview-add-button'}
                                        width={'30px'}
                                        height={'30px'}
                                        position={'relative'}
                                        hasBadge={!shouldShowLoader && !showCheckMark}
                                        onClick={() => addCard()}
                                    >
                                        {shouldShowLoader ? (
                                            <Spinner
                                                style={{
                                                    width: '16px',
                                                    height: '16px',
                                                    borderWidth: '3px',
                                                    borderTopWidth: '3px',
                                                }}
                                            />
                                        ) : showCheckMark ? (
                                            <CheckMarkImg src={CheckMark} />
                                        ) : (
                                            <>
                                                <AddCartIcon
                                                    mobilePath={AddBlue}
                                                />
                                                <CountBadge count={cartCount} />
                                            </>
                                        )}
                                    </AddCartButton>
                                </ActionButton>
                            )}
                    </>
                </ActionButton>
            )}

            {isOnlyPlusButton &&
                !isProductguidePage &&
                !isConsignmentAdd &&
                !isEquity && (
                    <ActionButton
                        enableTemplateCardSpecificStyling={
                            enableTemplateCardSpecificStyling
                        }
                        center={enableTemplateCardSpecificStyling}
                        paddingLeft={'0px'}
                        id={`add-cart-button-${productCFN || cfn || bom
                            }`}
                    >
                        <AddCartButton
                            visibility={
                                !shouldShowLoader && !showCheckMark &&
                                selectedSegment == 1 &&
                                    isSetDetailPage &&
                                    isEquity
                                    ? 'hidden'
                                    : ''
                            }
                            id='condensed-view-add-button'
                            onClick={() => {
                                if (!shouldShowLoader && !showCheckMark) {
                                    addCard();
                                }
                            }}
                        >
                            {shouldShowLoader ? (
                                <Spinner
                                    style={{
                                        width: '16px',
                                        height: '16px',
                                        borderWidth: '3px',
                                        borderTopWidth: '3px',
                                    }}
                                />
                            ) : showCheckMark ? (
                                <CheckMarkImg src={CheckMark} />
                            ) : (
                                <AddCartIcon mobilePath={AddBlue} />
                            )}
                        </AddCartButton>
                    </ActionButton>
                )}
        </ColumnContainer>
    );
};

export default ColumnContainerItems;
